var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 p-2 mb-2 bg-secondary text-white"},[_c('b-form-checkbox',{model:{value:(_vm.toggleStatus),callback:function ($$v) {_vm.toggleStatus=$$v},expression:"toggleStatus"}},[_vm._v("Toggle all")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }